var _class, _descriptor, _ThemeService_brand;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import Service from '@ember/service';
import { getOwnConfig, macroCondition } from '@embroider/macros';
import window from 'ember-window-mock';
import { tracked } from 'tracked-built-ins';
import APPEARANCE, { APPEARANCE_KEY, THEME } from '@qonto/ui-kit/constants/appearance-setting';
let ThemeService = (_class = (_ThemeService_brand = /*#__PURE__*/new WeakSet(), class ThemeService extends Service {
  constructor(...args) {
    super(...args);
    _classPrivateMethodInitSpec(this, _ThemeService_brand);
    _initializerDefineProperty(this, "currentTheme", _descriptor, this);
    _defineProperty(this, "onChange", e => _assertClassBrand(_ThemeService_brand, this, _handlePrefersColorSchemeChange).call(this, e));
    _defineProperty(this, "darkModeMediaQuery", window.matchMedia?.('(prefers-color-scheme: dark)'));
    _defineProperty(this, "darkAssets", {
      inlined: new Set(),
      other: new Set()
    });
  }
  get isCurrentThemeDark() {
    return this.currentTheme === THEME.DARK;
  }
  get isAutomaticSupported() {
    return isAutomaticSupported();
  }
  get localStorageAppearance() {
    return getLocalStorageAppearance();
  }
  setAppearance(appearance) {
    if (appearance === APPEARANCE.SYSTEM) {
      // Switching FROM light/dark TO automatic hence we add the event listener
      this.darkModeMediaQuery?.addEventListener?.('change', this.onChange);
    } else if (this.localStorageAppearance === APPEARANCE.SYSTEM) {
      // Switching FROM automatic to light/dark hence we remove the event listener
      this.darkModeMediaQuery?.removeEventListener?.('change', this.onChange);
    }
    _assertClassBrand(_ThemeService_brand, this, _toggleTheme).call(this, getTheme(appearance));
    try {
      window.localStorage.setItem(APPEARANCE_KEY, JSON.stringify(appearance));
      window.dispatchEvent(new StorageEvent('local-storage', {
        key: APPEARANCE_KEY
      }));
    } catch {
      // ignore errors
    }
  }
  _handleAnimationClass(appBody) {
    appBody.classList.add('dark-mode-animation');
    function onTransitionEnd() {
      appBody.classList.remove('dark-mode-animation');
      appBody.removeEventListener('transitionend', onTransitionEnd);
    }
    appBody.addEventListener('transitionend', onTransitionEnd);
  }
  pathForAsset(path) {
    if (macroCondition(getOwnConfig()?.supportsDarkMode)) {
      let isSvgJarIconId = /^[a-z0-9_-]+$/.test(path);
      let darkAssetExists = isSvgJarIconId ? this.darkAssets.inlined.has(path) : this.darkAssets.other.has(path);
      if (this.isCurrentThemeDark && darkAssetExists) {
        return isSvgJarIconId ? `${path}-dark` : path.replace(/\.(json|svg)/, '-dark.$1');
      }
    }
    return path;
  }
}), _descriptor = _applyDecoratedDescriptor(_class.prototype, "currentTheme", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return getTheme(getLocalStorageAppearance());
  }
}), _applyDecoratedDescriptor(_class.prototype, "setAppearance", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setAppearance"), _class.prototype), _class);
function _handlePrefersColorSchemeChange(e) {
  if (e.matches) {
    _assertClassBrand(_ThemeService_brand, this, _toggleTheme).call(this, THEME.DARK);
  } else {
    _assertClassBrand(_ThemeService_brand, this, _toggleTheme).call(this, THEME.LIGHT);
  }
}
function _toggleTheme(theme) {
  let appBody = document.querySelector('.ember-application');
  let shouldApplyAnimation = theme !== this.currentTheme;
  if (theme === THEME.DARK) {
    appBody.classList.add('dark-theme');
    this.currentTheme = THEME.DARK;
  } else {
    appBody.classList.remove('dark-theme');
    this.currentTheme = THEME.LIGHT;
  }
  if (shouldApplyAnimation) {
    this._handleAnimationClass(appBody);
  }
}
export { ThemeService as default };
function getDeviceTheme() {
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? THEME.DARK : THEME.LIGHT;
}
function getLocalStorageAppearance() {
  try {
    let appearance = window.localStorage.getItem(APPEARANCE_KEY);
    let parsed = appearance && JSON.parse(appearance);
    return Object.values(APPEARANCE).includes(parsed) ? parsed : APPEARANCE.SYSTEM;
  } catch {
    return APPEARANCE.SYSTEM;
  }
}
function getTheme(appearance) {
  if (appearance === APPEARANCE.SYSTEM) {
    return isAutomaticSupported() ? getDeviceTheme() : THEME.LIGHT;
  }
  return appearance === APPEARANCE.DARK ? THEME.DARK : THEME.LIGHT;
}
function isAutomaticSupported() {
  return window.matchMedia?.('(prefers-color-scheme)').media !== 'not all';
}